import { generateId } from './generateId';

// ── Datenmodell ────────────────────────────────────────────────
export interface Massnahme {
  id: string;
  schwachstelleId: string; // Referenz auf Schwachstelle.id - PFLICHT
  bezeichnung: string;
  beschreibung: string;
  aufwand: 'gering' | 'mittel' | 'erhoeht' | '';
}

export interface Section5Data {
  massnahmen: Massnahme[];
}

// ── Migration ──────────────────────────────────────────────────
export function migrateMassnahme(old: any): Massnahme {
  if (old.id && old.schwachstelleId !== undefined) return old;
  return {
    id: generateId(),
    schwachstelleId: old.schwachstelleId || '',
    bezeichnung: old.text || old.bezeichnung || '',
    beschreibung: old.beschreibung || '',
    aufwand: old.aufwand || '',
  };
}
